import routes from 'features/Payments/routes';

const root = `${routes.root}/mandates`;

const newMandates = `${root}/add`;

export default {
  newMandates,
  root,
} as const;
